import React, { useRef, useState } from 'react';
import { Button } from 'reactstrap';
import { FaBan } from 'react-icons/fa';
import Swal from 'sweetalert2';
import axiosInstance from '../../services/api_helper';

export default function CancelDocumentButton({ document, endpoint, onCancelled, method = 'post', reasonRequired = false }) {
    const [busy, setBusy] = useState(false);
    const pending = useRef(false);
    const reference = document.numero || document.numeroRetour || document.reference || 'ce document';
    if (['ANNULE', 'ANNULEE', 'REFUSE'].includes(document.status || document.statut)) return null;

    const cancel = async () => {
        if (pending.current) return;
        pending.current = true;
        setBusy(true);
        try {
            const answer = await Swal.fire({
                title: `Annuler ${reference} ?`,
                text: 'Le document sera conservé avec son statut annulé. Les documents liés ou réglés peuvent nécessiter une annulation préalable.',
                icon: 'warning',
                input: reasonRequired ? 'text' : undefined,
                inputLabel: reasonRequired ? "Motif d’annulation" : undefined,
                inputValidator: reasonRequired ? value => !value?.trim() ? 'Veuillez saisir un motif.' : undefined : undefined,
                showCancelButton: true,
                confirmButtonText: "Confirmer l’annulation",
                cancelButtonText: 'Conserver le document',
                confirmButtonColor: '#dc3545',
            });
            if (!answer.isConfirmed) return;
            await axiosInstance.request({ method, url: endpoint, params: reasonRequired ? { motifAnnulation: answer.value.trim() } : undefined });
            onCancelled();
            await Swal.fire({ icon: 'success', title: 'Document annulé', timer: 1500, showConfirmButton: false });
        } catch (error) {
            const data = error.response?.data;
            await Swal.fire('Annulation impossible', data?.message || data?.error || (typeof data === 'string' ? data : null) || error.message, 'error');
        } finally {
            pending.current = false;
            setBusy(false);
        }
    };

    return <Button color="danger" outline size="sm" disabled={busy} onClick={cancel} title="Annuler le document" aria-label={`Annuler ${reference}`}><FaBan className="me-1" />{busy ? 'Annulation…' : 'Annuler'}</Button>;
}
